"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const checkbox_style_1 = __importDefault(require("./checkbox.style"));
const Checkbox = ({ classes, className, checked, onClick, boxStyle }) => (jsx_runtime_1.jsx("div", { "data-cy": "atomic-checkbox", className: classnames_1.default(classes.root, className, {
        [classes.checked]: checked,
        [classes.checkbox]: boxStyle === 'checkbox',
        [classes.radio]: boxStyle === 'radio'
    }), onClick: onClick }, void 0));
Checkbox.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    className: prop_types_1.default.string,
    checked: prop_types_1.default.bool,
    onClick: prop_types_1.default.func.isRequired,
    boxStyle: prop_types_1.default.oneOf(['checkbox', 'radio'])
};
Checkbox.defaultProps = {
    className: null,
    checked: false,
    boxStyle: 'checkbox'
};
exports.default = react_jss_1.default(checkbox_style_1.default)(Checkbox);
//# sourceMappingURL=index.js.map